import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import TimelineProvider from '../../../../../contexts/TimelineContext'
import TimelineContent from '../TimelineParts/TimelineContent'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'

/**
 * Full campaign timeline (sidebar filters, calendar) for the advertiser shared campaign report.
 * Read-only: no notes, no drag-and-drop, no API mutations.
 */
export default observer(function SharedCampaignReportTimeline() {
  const { selectedScenario } = useContext(SharedCampaignContext)

  if (!selectedScenario) return null

  return (
    <section className="w-full">
      <h2 className="py-2 text-xl font-bold dark:text-white">Timeline</h2>
      <p className="mb-3 text-sm text-rb-lighter-grey dark:text-gray-400">
        Project and scenario placements across the campaign period. This view is read-only.
      </p>
      <TimelineProvider campaignScenario={selectedScenario} readonly layout="embedded">
        <TimelineContent />
      </TimelineProvider>
    </section>
  )
})
